import script from "./LeaderCompetenciesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderCompetenciesCard.vue?vue&type=script&setup=true&lang=js"

import "./LeaderCompetenciesCard.vue?vue&type=style&index=0&id=54d72e00&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54d72e00"]])

export default __exports__